import React from 'react';

/**
 * interface TabProps
 */
interface TabProps {
  data: {
    key: string;
  };
  config: {
    activeTab: string;
  };
  eventHandlers: {
    onClickHandler: (key: string) => void;
  };
}

/**
 * functional component Tab
 * @param config holds component configuration
 * @param data holds component data
 * @param eventHandlers holds component event handlers
 */
export const Tab: React.FC<TabProps> = ({ config, data, eventHandlers }) => {
  const onClick = () => {
    eventHandlers.onClickHandler(data.key);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <li
      role="tab"
      aria-selected={config.activeTab === data.key}
      tabIndex={0}
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={
        config.activeTab === data.key
          ? 'p-2  whitespace-nowrap rounded-lg bg-primary-600 text-white shadow-elevation-1 cursor-pointer select-none transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-primary-300 font-gilroy-regular'
          : 'p-2  whitespace-nowrap rounded-lg text-primary-700 hover:text-primary-600 hover:bg-primary-50 cursor-pointer select-none transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary-100'
      }
    >
      {data.key}
    </li>
  );
};
